import React, { useMemo } from 'react';

interface BadgeProps {
  text: string;
  selected: boolean;
  onClick: () => void;
}

export default function Badge({ text, selected, onClick }: BadgeProps) {
  const style = useMemo(() => {
    if (selected) return 'bg-primary text-on-primary border-transparent font-semibold';

    return 'border-gray-400 text-gray-900';
  }, [selected]);

  return (
    <button
      className={`px-7 py-2 text-sm ${style} cursor-pointer select-none rounded-[100px] border border-solid`}
      onClick={onClick}
    >
      {text}
    </button>
  );
}
